function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.2474 14.2333L18.3399 14.8639L17.2474 14.2333Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.73933 11.7456C7.73933 8.94327 10.0131 6.66947 12.8154 6.66947C12.8554 6.66947 12.8954 6.66947 12.9353 6.67392V2.93014C12.8954 2.93014 12.8554 2.93014 12.8154 2.93014C7.94806 2.93014 4 6.8782 4 11.7456C4 13.3754 4.43966 14.8987 5.2124 16.2043L8.45434 14.3347C8.00135 13.5797 7.73933 12.6915 7.73933 11.7456Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.1099 17.9187L16.4674 15.2763C15.5704 16.2045 14.3224 16.7907 12.9413 16.8218V20.5611C13.6607 20.5522 14.358 20.4545 15.0241 20.2857C15.1662 20.2502 15.3039 20.2102 15.4416 20.1658C16.8494 19.7306 18.1062 18.949 19.1099 17.9187Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.8163 16.8226C10.96 16.8226 9.33456 15.8234 8.4508 14.3357L5.20886 16.2053C6.19921 17.8929 7.74024 19.2252 9.58326 19.9491C9.91634 20.0823 10.2627 20.1934 10.6136 20.2822C11.3197 20.4643 12.0569 20.5575 12.8163 20.5575C12.8563 20.5575 12.8963 20.5575 12.9362 20.5575V16.8137C12.8963 16.8226 12.8563 16.8226 12.8163 16.8226Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.1074 17.9193C19.6403 17.3775 20.1022 16.7691 20.4797 16.103L18.3302 14.8639L17.2377 14.2333C17.0246 14.6152 16.7626 14.9616 16.4606 15.2769L19.1074 17.9193Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.7258 5.55084L13.3914 10.3072L11.4551 8.48191L9.02142 11.0666L13.5868 15.361L20.3505 7.94454L17.7258 5.55084Z"
});

var SvgTadaSmall = function SvgTadaSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTadaSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tada-small.e85c4d90.svg";
export { ForwardRef as ReactComponent };